/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { EnumerationValueDto } from './EnumerationValueDto';
import {
    EnumerationValueDtoFromJSON,
    EnumerationValueDtoFromJSONTyped,
    EnumerationValueDtoToJSON,
} from './EnumerationValueDto';
import type { NumericValueDto } from './NumericValueDto';
import {
    NumericValueDtoFromJSON,
    NumericValueDtoFromJSONTyped,
    NumericValueDtoToJSON,
} from './NumericValueDto';
import type { NumericListDto } from './NumericListDto';
import {
    NumericListDtoFromJSON,
    NumericListDtoFromJSONTyped,
    NumericListDtoToJSON,
} from './NumericListDto';

/**
 * 
 * @export
 * @interface ElectronBeamQualityDto
 */
export interface ElectronBeamQualityDto {
    /**
     * 
     * @type {string}
     * @memberof ElectronBeamQualityDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ElectronBeamQualityDto
     */
    readonly creationTime?: string;
    /**
     * 
     * @type {number}
     * @memberof ElectronBeamQualityDto
     */
    readonly creatorUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ElectronBeamQualityDto
     */
    lastModificationTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ElectronBeamQualityDto
     */
    readonly lastModifierUserId?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof ElectronBeamQualityDto
     */
    readonly isDeleted?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ElectronBeamQualityDto
     */
    readonly deleterUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ElectronBeamQualityDto
     */
    readonly deletionTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ElectronBeamQualityDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ElectronBeamQualityDto
     */
    iuid?: string | null;
    /**
     * 
     * @type {NumericListDto}
     * @memberof ElectronBeamQualityDto
     */
    availableDoseRates: NumericListDto;
    /**
     * 
     * @type {EnumerationValueDto}
     * @memberof ElectronBeamQualityDto
     */
    radiationType: EnumerationValueDto;
    /**
     * 
     * @type {NumericValueDto}
     * @memberof ElectronBeamQualityDto
     */
    energy: NumericValueDto;
    /**
     * 
     * @type {EnumerationValueDto}
     * @memberof ElectronBeamQualityDto
     */
    highDoseTechniqueType: EnumerationValueDto;
    /**
     * 
     * @type {string}
     * @memberof ElectronBeamQualityDto
     */
    $type?: ElectronBeamQualityDtoTypeEnum;
}


/**
 * @export
 */
export const ElectronBeamQualityDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedMedicalSystemComponentDtoTreatmentMachinesConfigurationElectronBeamQualityDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.TreatmentMachines.Configuration.ElectronBeamQualityDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type ElectronBeamQualityDtoTypeEnum = typeof ElectronBeamQualityDtoTypeEnum[keyof typeof ElectronBeamQualityDtoTypeEnum];



/**
 * Check if a given object implements the ElectronBeamQualityDto interface.
 */
export function instanceOfElectronBeamQualityDto(value?: unknown): value is ElectronBeamQualityDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(ElectronBeamQualityDtoTypeEnum)[0];
}

export function ElectronBeamQualityDtoFromJSON(json: any): ElectronBeamQualityDto {
    return ElectronBeamQualityDtoFromJSONTyped(json, false);
}

export function ElectronBeamQualityDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ElectronBeamQualityDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'creationTime': json['creationTime'] == null ? undefined : json['creationTime'],
        'creatorUserId': json['creatorUserId'] == null ? undefined : json['creatorUserId'],
        'lastModificationTime': json['lastModificationTime'] == null ? undefined : json['lastModificationTime'],
        'lastModifierUserId': json['lastModifierUserId'] == null ? undefined : json['lastModifierUserId'],
        'isDeleted': json['isDeleted'] == null ? undefined : json['isDeleted'],
        'deleterUserId': json['deleterUserId'] == null ? undefined : json['deleterUserId'],
        'deletionTime': json['deletionTime'] == null ? undefined : json['deletionTime'],
        'name': json['name'],
        'iuid': json['iuid'] == null ? undefined : json['iuid'],
        'availableDoseRates': NumericListDtoFromJSON(json['availableDoseRates']),
        'radiationType': EnumerationValueDtoFromJSON(json['radiationType']),
        'energy': NumericValueDtoFromJSON(json['energy']),
        'highDoseTechniqueType': EnumerationValueDtoFromJSON(json['highDoseTechniqueType']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function ElectronBeamQualityDtoToJSON(value?: Omit<ElectronBeamQualityDto, 'creationTime'|'creatorUserId'|'lastModifierUserId'|'isDeleted'|'deleterUserId'|'deletionTime'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'lastModificationTime': value['lastModificationTime'],
        'name': value['name'],
        'iuid': value['iuid'],
        'availableDoseRates': NumericListDtoToJSON(value['availableDoseRates']),
        'radiationType': EnumerationValueDtoToJSON(value['radiationType']),
        'energy': NumericValueDtoToJSON(value['energy']),
        'highDoseTechniqueType': EnumerationValueDtoToJSON(value['highDoseTechniqueType']),
        '$type': value['$type'],
    });
}

